import { Button } from 'components/ui/button';
import { Input } from 'components/ui/input';
import { cn } from 'lib/utils';
import { EyeIcon, EyeOffIcon } from 'lucide-react';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * An `Input` for a secret, with the eye button that reveals it. The button
 * sits in the trailing icon slot, so callers keep their own leading icon.
 */
function PasswordInput({ className, ...props }: Omit<React.ComponentProps<typeof Input>, 'type'>) {
  const { t } = useTranslation();
  const [visible, setVisible] = React.useState(false);

  return (
    <div className="relative">
      {/* room for the eye button */}
      <Input type={visible ? 'text' : 'password'} className={cn('pr-11', className)} {...props} />
      <Button
        type="button"
        variant="ghost"
        size="icon"
        className="absolute top-1/2 right-1.5 -translate-y-1/2 text-muted-foreground hover:bg-transparent"
        aria-label={t(visible ? 'loginRegister.fields.password.hide' : 'loginRegister.fields.password.show')}
        aria-pressed={visible}
        onClick={() => setVisible(v => !v)}
        tabIndex={-1}
      >
        {visible ? <EyeOffIcon /> : <EyeIcon />}
      </Button>
    </div>
  );
}

export { PasswordInput };
